export enum ScanTabs {
    Guide = 'Guide',
    Scan = 'Scan',
    Settings = 'Settings',
    DataCollectorSettings = 'Collector',
}
